const app = {
    title: 'Dashboard',
    subtitle: 'API Monetization Platform',
    description: 'Multi-tenant SaaS for automation agencies',
    
    // Main sections
    apiProducts: 'API Products',
    customerAnalytics: 'Customer Analytics',
    quickActions: 'Quick Actions',
    
    // Status messages
    reactReady: 'React Ready',
    shadcnReady: 'shadcn/ui Ready',
    typescriptReady: 'TypeScript Ready',
    configuredMessage: 'If you can see this beautifully styled page with shadcn/ui components, React is fully configured and ready for development!',
    
    // Test section
    reactTest: 'React Test',
    testDescription: 'Interactive tests to verify React functionality',
    stateManagementTest: 'State Management Test:',
    eventHandlerTest: 'Event Handler Test:',
    configurationStatus: 'Configuration Status',
    allSystemsGo: 'All Systems Go',
    environmentTitle: 'Environment',
    environmentDescription: 'Development environment configuration',
    
    // Button variants
    buttonVariants: 'shadcn/ui Button Variants',
    buttonDescription: 'Showcasing different button styles and sizes',
    
    // Actions
    testReact: 'Test React',
    testAgain: 'Test Again',
    ghostStyle: 'Ghost Style',
    reset: 'Reset',
    count: 'Count: {{count}}',
    
    // Environment info
    mode: 'Mode:',
    development: 'development',
    apiUrl: 'API URL:',
    notSet: 'Not set',
    hotReload: 'Hot Reload:',
    port: 'Port:',
    localDevelopment: 'Local Development',
  } as const;

export default app;
